var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98792 11.9C6.33769 11.9 6.68772 11.7709 6.9612 11.5113C7.52649 10.9738 7.54903 10.0795 7.01173 9.51399L3.85135 6.19011L7.00851 2.88928C7.54779 2.32572 7.52798 1.43146 6.96417 0.891932C6.40012 0.352403 5.50611 0.372468 4.96682 0.936273L0.878248 5.21014C0.35705 5.75512 0.35606 6.61346 0.875028 7.16018L4.96336 11.4608C5.24154 11.7524 5.61386 11.9 5.98792 11.9Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrevious);
export default __webpack_public_path__ + "static/media/arrow_previous.437918600f082728cd87af74be10c180.svg";
export { ForwardRef as ReactComponent };